import { Tag } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { QUOTE_CATEGORIES } from "@/lib/constants";

export const CategoryPicker = ({ value, onChange }) => (
  <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
    <SelectTrigger className={`w-44 h-9 ${value ? "border-amber-400/50 text-amber-300" : "text-slate-400"}`} data-testid="quote-category-select">
      <Tag className="h-3.5 w-3.5 mr-1 shrink-0" /><SelectValue placeholder="Categoria" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="none" data-testid="quote-category-none">Nessuna categoria</SelectItem>
      {QUOTE_CATEGORIES.map((c) => <SelectItem key={c} value={c} data-testid={`quote-category-${c.toLowerCase()}`}>{c}</SelectItem>)}
    </SelectContent>
  </Select>
);
